<template>
  <div class="columns">
    <div class="column is-3">
      <r-label
        label="Type d'annexe"
        :value="a.annex_type"></r-label>
      <div class="control">
        <div class="select is-fullwidth">
          <select v-model="a.annex_type">
            <option value="">
              Selectionnez le type
            </option>
            <option
              v-for="c in annexesList"
              :value="c.value"
              :key="c.value">
              {{ c.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="column is-2">
      <r-label
        label="Surf. m²"
        for="remuneration"
        :is-required="false"></r-label>
      <div class="control">
        <v-input
          :id="'annex_surface' + a.pk"
          :name="'annex_surface' + a.pk"
          @input="a.surface = $event"
          :model="a.surface"
          input-type="number"
          :number="true"
          :three-space="true"
          :errors-bag="errors"
          data-vv-value-path="val"
          data-vv-as="Surface">
        </v-input>
      </div>
    </div>
    <div class="column is-7">
      <r-label
        label="Détails / Informations / N°"
        for="remuneration"
        :is-required="false"></r-label>
      <div class="control">
        <v-input
          :has-addons="true"
          :id="'annex_info' + a.pk"
          :name="'annex_info' + a.pk"
          @input="a.info = $event"
          :model="a.info"
          :errors-bag="errors"
          data-vv-value-path="val"
          data-vv-as="Infos">
          <p
            class="control"
            slot="addonRight">
            <a
              @click="removeAnnex"
              class="button is-square is-grey is-inverted is-border">
              <span class="icon"><i class="fal fa-trash-alt fa-lg"></i></span>
            </a>
          </p>
        </v-input>
      </div>
    </div>
    <div style="display: none;">
      <div class="field">
        <div class="control">
          <v-input
            :id="'annex_is_parking' + a.pk"
            :name="'annex_is_parking' + a.pk"
            @input="a.is_parking = $event"
            :model="a.is_parking"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="Infos">
          </v-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues } from '../../mixins'

export default {
  name: 'AnnexeItem',
  mixins: [DefaultValues],
  props: {
    source: {
      type: Object,
      required: true
    }
  },
  computed: {
    a () {
      return Object.assign(this.source)
    }
  },
  methods: {
    removeAnnex () {
      this.$emit('removeAnnex')
    }
  }
}
</script>
